import React from 'react';

export const ScrollArea = function ({ children }) {
  return <div className="WorkshopsOverlay__ScrollArea">{children}</div>;
};
